export default "__VITE_ASSET__EsyB0Lm2__"